import styled from 'styled-components';

const REVIEW_CARD_WIDTH = 415;
const REVIEWS_GAP = 24;

export const ApplicationReviewStyled = styled.div<{ $currIndex: number }>`
	translate: -${props => props.$currIndex * (REVIEW_CARD_WIDTH + REVIEWS_GAP)}px;

	padding: 0 16px 12px 16px;
	min-width: 300px;
	height: 288px;
	border-radius: 12px;
	background-color: #fafafa;
	transition: 300ms ease;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		min-width: 415px;
		padding: 12px 24px;
	}
`;

export const ReviewHeaderStyled = styled.div`
	gap: 16px;
	display: flex;
	padding: 12px 0;
`;

export const ReviewHeaderTextContainerStyled = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ReviewContentStyled = styled.div`
	gap: 8px;
	display: flex;
	flex-direction: column;
	padding: 8px 0;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		padding: 12px 0;
	}
`;
